const initialState = {
    open: false,
    title: '',
    message: '',
    payload: null,
    mode: '',
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'SHOW_MODAL':
            return {
                ...state,
                open: true,
                title: action.payload?.title || '',
                message: action.payload?.message || '',
                payload: action.payload?.payload || null,
                callback: action.payload.callback || null
            };

        case 'HIDE_MODAL':
            return {
                ...state,
                open: false,
                title: '',
                message: '',
                payload: null,
            };

        default:
            return state;
    }
};

export default modalReducer;
